<!-- <app-header-one></app-header-one> -->
<app-header-latest></app-header-latest>

<section class="login-page section-b-space">
    <div class="container">
        <div class="">
            <div class="row mt-5">
                <div class="col-lg-8 offset-lg-2">
                    <div class="alert alert-light alert-dismissible" *ngIf="validForgetEmail">
                        <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
                        <strong>Password is sent to:</strong>
                        <ng-container *ngIf="isMobile(forgetEmail); else showEmail">
                            +91{{ forgetEmail.replace('+91', '') }}
                        </ng-container>
                        <ng-template #showEmail>&nbsp;{{ forgetEmail }}</ng-template>
                    </div>
                </div>


                <!-- <div class="col-lg-8 offset-lg-2">
                    <div class="alert alert-light alert-dismissible" *ngIf="validForgetEmail">
                        <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
                        <strong>Password is sent to email: </strong> {{forgetEmail}}
                    </div>
                </div> -->

                <div class="col-lg-6 offset-lg-3 ">
                    <div class="theme-card">
                        <h2> Vendor <b>/</b> Employee Forgot Password</h2>
                        <form [formGroup]="form" (ngSubmit)="onSubmit()">
                            <div class="form-group form-group-change">
                                <mat-form-field appearance="outline">
                                    <mat-label>Email or Mobile</mat-label>
                                    <input matInput type="text" formControlName="email_or_mobile" placeholder="Enter your email or phone no">
                                  
                                </mat-form-field>
                                 <mat-error
                                        *ngIf="form.get('email_or_mobile')?.errors?.invalidMobile && (form.get('email_or_mobile')?.touched || form.get('email_or_mobile')?.dirty)">
                                        Enter a valid 10-digit mobile number.
                                    </mat-error>

                                    <mat-error
                                        *ngIf="form.get('email_or_mobile')?.errors?.invalidEmail && (form.get('email_or_mobile')?.touched || form.get('email_or_mobile')?.dirty)">
                                        Enter a valid email address.
                                    </mat-error>

                                    <mat-error
                                        *ngIf="form.get('email_or_mobile')?.errors?.required && form.get('email_or_mobile')?.dirty">
                                        This field is required.
                                    </mat-error>
                            </div>

                            <!-- <div class="form-group form-group-custom">
                                <mat-form-field appearance="outline">
                                    <mat-label>Mobile</mat-label>
                                    <input matInput type="mobile" id="password" formControlName="mobile"
                                        placeholder="mobile">
                                    <button mat-icon-button type="button" matSuffix>
                                    </button>
                                    <mat-error *ngIf="adminLoginForm.get('mobile').hasError('required')">Mobile is
                                        required.</mat-error>
                                </mat-form-field>
                            </div> -->
                            <div class="d-flex justify-content-between mt-4">
                                <span>Back to Login?
                                    <a (click)="goTo('/sign-in')" id="business-partner-sign-in"
                                        class="forgot-password-link primary-color" style="cursor: pointer;">
                                        Sign In
                                    </a>
                                </span>
                                <button type="submit" class="btn btn-solid _button">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <app-footer-one></app-footer-one> -->
<app-our-apps></app-our-apps>
<!-- <app-footer-more-info></app-footer-more-info> -->
 <app-peopleflow-footer></app-peopleflow-footer>